import {Component, OnInit} from '@angular/core';
import {ButtonComponent} from "../../shared/components/button/button.component";
import {TranslatePipe} from "@ngx-translate/core";
import {
  ImageTextCardWrapperComponent
} from "../../shared/components/image-text-card-wrapper/image-text-card-wrapper.component";
import {HomeTeamCardsComponent} from "./home-team-cards/home-team-cards.component";
import {HomeHpsCardComponent} from "./home-hps-card/home-hps-card.component";
import {HomeFreeConsultationComponent} from "./home-free-consultation/home-free-consultation.component";
import {HomeClientFeedbackComponent} from "./home-client-feedback/home-client-feedback.component";

@Component({
  selector: 'app-home-page',
  imports: [
    ButtonComponent,
    TranslatePipe,
    ImageTextCardWrapperComponent,
    HomeTeamCardsComponent,
    HomeHpsCardComponent,
    HomeFreeConsultationComponent,
    HomeClientFeedbackComponent,
  ],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss'
})
export class HomePageComponent implements OnInit {
  // add in the service page consulting services, Digital Transformation, etc.
  services = [
    {
      icon: 'assets/images/sector/consulting.png',
      title: 'home-page.services-title-consulting',
      description: 'home-page.services-description-consulting',
    },
    {
      icon: 'assets/images/services/cloud-and-infrastructure.png',
      title: 'home-page.services-title-cloud',
      description: 'home-page.services-description-cloud',
    },
    {
      icon: 'assets/images/services/software-dev.png',
      title: 'home-page.services-title-software-dev',
      description: 'home-page.services-description-software-dev',
    },
    {
      icon: 'assets/images/services/security-and-compliance.png',
      title: 'home-page.services-title-sec-and-comp',
      description: 'home-page.services-description-sec-and-comp'
    },
  ];

  barColors: string[] = [
    '#68232A',
    '#AA6C2B',
    '#532B14',
    '#8B6D48',
    '#C78B4A',
    '#77633D'
  ];

  ngOnInit(): void {
    setInterval(() => {
      this.rotateBars();
    }, 2000);
  }

  rotateBars() {
    // circular shifting (180° effect)
    const first = this.barColors.shift();
    if (first) this.barColors.push(first);
  }

  onContactClick() {
    console.log("Contact Clicked");
  }
}
